var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"headline justify-center grey lighten-2"},[_vm._v(_vm._s(_vm.title))]),_c('v-col',{staticClass:"center",attrs:{"cols":"6"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }